import React, { useState } from 'react';
import logo from '../img/logo.svg';
import { css } from 'emotion';
import { Menu } from '@material-ui/icons';
import { Link } from 'react-router-dom';

function Navigation() {
  const [menuVisible, setMenuVisible] = useState(false);
  const hideMenu = () => setMenuVisible(false);

  return (
    <React.Fragment>
      <div className={style.placeholder}></div>
      <div className={style.container}>
        <div className={style.navigation}>
          <img src={logo} alt="" className={style.logo} />
          <Link to="/" className={style.item} onClick={hideMenu}>
            Start
          </Link>
          <Link to="/info" className={style.item} onClick={hideMenu}>
            Info
          </Link>
          <Link to="/oeffnungszeiten" className={style.item} onClick={hideMenu}>
            &Ouml;ffnungszeiten
          </Link>
          <Link to="/preise" className={style.item} onClick={hideMenu}>
            Preise
          </Link>
          <Link to="/impressum" className={style.item} onClick={hideMenu}>
            Impressum
          </Link>
          <Menu className={style.icon} onClick={() => setMenuVisible(!menuVisible)} />
        </div>
        <div className={style.menu(menuVisible)}>
          <Link to="/" onClick={hideMenu} className={style.menuItemLink}>
            <div className={style.menuItem}>Start</div>
          </Link>
          <Link to="/info" onClick={hideMenu} className={style.menuItemLink}>
            <div className={style.menuItem}>Info</div>
          </Link>
          <Link to="/oeffnungszeiten" onClick={hideMenu} className={style.menuItemLink}>
            <div className={style.menuItem}>&Ouml;ffnungszeiten</div>
          </Link>
          <Link to="/preise" onClick={hideMenu} className={style.menuItemLink}>
            <div className={style.menuItem}>Preise</div>
          </Link>
          <Link to="/impressum" onClick={hideMenu} className={style.menuItemLink}>
            <div className={style.menuItem}>Impressum</div>
          </Link>
        </div>
      </div>
      <div
        className={style.curtain(menuVisible)}
        onClick={() => {
          setMenuVisible(false);
        }}
      ></div>
    </React.Fragment>
  );
}

const style = {
  placeholder: css`
    padding-bottom: 50px;
    width: 100%;
  `,
  container: css`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    min-width: 320px;
    background-color: #ffffff;
    z-index: 99;
    -webkit-box-shadow: 0px 5px 5px 0px rgba(0, 0, 0, 0.5);
    -moz-box-shadow: 0px 5px 5px 0px rgba(0, 0, 0, 0.5);
    box-shadow: 0px 5px 5px 0px rgba(0, 0, 0, 0.5);
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
  `,
  navigation: css`
    padding: 0 10px;
    max-width: 1200px;
    margin-left: auto;
    margin-right: auto;
    height: 50px;
    line-height: 50px;
    display: flex;
    @media (max-width: 640px) {
      justify-content: space-between;
    }
  `,
  logo: css`
    height: 40px;
    margin: 5px;
  `,
  item: css`
    color: #000000;
    text-decoration: none;
    padding: 0 20px;
    cursor: pointer;
    &:hover {
      color: #d30e39;
    }
    @media (max-width: 640px) {
      display: none;
    }
  `,
  icon: css`
    font-size: 24px !important;
    padding: 13px 0%;
    cursor: pointer;
    &:hover {
      color: #d30e39;
    }
    @media (min-width: 641px) {
      display: none !important;
    }
  `,
  menu: (visible: boolean) => css`
    display: flex;
    flex-direction: column;
    border-top: 1px solid #efefef;
    display: ${visible ? 'block' : 'none !important'};
    @media (min-width: 641px) {
      display: none !important;
    }
  `,
  menuItem: css`
    text-align: center;
    cursor: pointer;
    padding: 5px;
    &:hover {
      background-color: #f3f3f3;
    }
  `,
  menuItemLink: css`
    color: #000000;
    text-decoration: none;
    &:hover {
      color: #d30e39;
    }
  `,
  curtain: (visible: boolean) => css`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9;
    background-color: black;
    opacity: 0.5;
    display: ${visible ? 'block' : 'none !important'};
    @media (min-width: 641px) {
      display: none !important;
    }
  `,
};

export default Navigation;
